'use strict';

/**
 * True only when Karma loads test.app.js (sets window.__GBIP_UNIT_TEST__).
 *
 * Not a product flag — React cutover is always on in production. Unit tests still
 * bootstrap the legacy gbip module and drive ui-router state names (search, detail,
 * queue.*, admin). If we intercept those here the way production does
 * (preventDefault + ReactNavigationService / location.assign), ui-router and digest
 * fight the redirect and specs fail (mass $rootScope:infdig after we removed
 * FeatureFlagService, which used to defer $urlRouter.sync and skip redirects via
 * isEnabled() === false in featureFlagMock.js).
 *
 * app.setup.js uses the same check to skip $urlRouter.listen/sync on boot.
 */
function isGbipUnitTestHarness() {
  return typeof window !== 'undefined' && window.__GBIP_UNIT_TEST__ === true;
}

module.exports = isGbipUnitTestHarness;
